// extracted by mini-css-extract-plugin
export default {"alertTriangle":"styles-module--alertTriangle--O7X9q","feedbackText":"styles-module--feedbackText--nxz8U"};